module.exports = "input{width:100%}\n"